import { ApiResponse } from '@nano/core/api';

export const VERIFICATION_STORAGE_KEY = 'vrf';

export enum AutoKycRejectionType {
  VERIFICATION = 'VERIFICATION',
  MEDIA = 'MEDIA',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  BROWSER_INFORMATION = 'BROWSER_INFORMATION'
}

export interface AutoKycRejectionReason {
  key: string;
  title: string;
  type: AutoKycRejectionType;
}

export enum KycRenewalStatus {
  VALID = 'VALID',
  NOTIFY = 'NOTIFY',
  REMIND = 'REMIND',
  OVERDUE = 'OVERDUE'
}

export interface VerificationStartResponse extends ApiResponse {
  redirectUrl: string;
}

export enum VerificationStatus {
  CREATED = 'CREATED',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  RESUBMISSION = 'RESUBMISSION',
  ABANDONED = 'ABANDONED',
  EXPIRED = 'EXPIRED'
}

export enum VerificationStage {
  TIER_1 = 'TIER_1',
  TIER_2 = 'TIER_2',
  TIER_3 = 'TIER_3',
  MEDIA = 'MEDIA',
  TIER_BUSINESS = 'TIER_BUSINESS'
}

export interface Verification {
  id: string;
  kycRenewalStatus: KycRenewalStatus;
  stages: VerificationStage[];
  stage: VerificationStage;
  status: VerificationStatus;
  success: boolean;
  rejectionReasons?: AutoKycRejectionReason[];
  failCritical: boolean;
  failReason: string;
  redirectUrl?: string;
  publicNotes?: string;
  requiredComplianceLevel?: string;
  kycRenewalMessage?: string;
  renewal?: boolean;
  alreadyStarted?: boolean;
  alreadyStartedByThisUser?: boolean;
  needToAcknowledge?: boolean;
  authorisedForThisUser?: boolean;
  authorizedDataReviewers?: string[];
}

export function complianceLevelToVerificationStage(complianceLevel: string): VerificationStage {
  switch (Number(complianceLevel)) {
    case 1:
      return VerificationStage.TIER_1;
    case 2:
      return VerificationStage.TIER_2;
    case 3:
      return VerificationStage.TIER_3;
  }
}

export interface VerificationPaymentStage {
  canStartVerification: boolean;
  status: string;
  date: string;
  stage: VerificationStage;
}
